
import { Link2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CardResourceStack, TypographyResourceLabel } from "./CardResourceStack.styles";
import type { CardTabsLinkProps } from "./CardTabsLink.types";
import { TruncatedText } from "../../components/TruncatedText/TruncatedText.component";

export function CardTabsLink({
  description,
  disabled,
  url_label,
  url,
  ...props
}: CardTabsLinkProps) {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    if (!disabled && url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <CardResourceStack
      tabIndex={ 0 }
      aria-label={ t("go_to_link",{ link:url_label }) }
      { ...props }
      onClick={ handleLinkClick }
      $disabled={ disabled }
    >
      <Link2 size={ "1rem" } />
      <TruncatedText 
        text={ url_label }
        webkitLineClamp={ 1 }
      >
        <TypographyResourceLabel>
          { url_label }
        </TypographyResourceLabel>    
      </TruncatedText>
    </CardResourceStack>
  );
}
